<template>
    <article class="rounded-[12.8px] border border-gray-200 bg-white p-[21px]">
        <div class="mb-4 flex items-start justify-between gap-4">
            <div>
                <p class="font-medium text-gray-900">{{ title }}</p>
                <p class="mt-1 text-[13px] leading-[18px] text-gray-500">
                    {{ subtitle }}
                </p>
            </div>
            <Link
                v-if="linkHref !== null && linkLabel !== null"
                :href="linkHref"
                class="shrink-0 text-[13px] font-medium leading-[18px] text-[#088BEA] hover:underline"
            >
                {{ linkLabel }}
            </Link>
        </div>

        <slot />
    </article>
</template>

<script lang="ts" setup>
import { Link } from "@inertiajs/vue3";

withDefaults(
    defineProps<{
        title: string;
        subtitle: string;
        linkHref?: string | null;
        linkLabel?: string | null;
    }>(),
    {
        linkHref: null,
        linkLabel: null,
    },
);
</script>
